module.exports = __webpack_public_path__ + "static/media/5_r_holst_92.71_63.8.49266967.png";